import { FC } from "react";

interface ClassicI2FBadgeProps {
  size?: "sm" | "md";
  className?: string;
}

// Square "Classic / i2F" badge used wherever the Classic i2File icon is shown
const ClassicI2FBadge: FC<ClassicI2FBadgeProps> = ({
  size = "md",
  className,
}) => (
  <span
    className={`classic-i2f-badge classic-i2f-badge-${size} ${
      className || ""
    }`.trim()}
    aria-hidden="true"
  >
    <span>Classic</span>
    <span>i2F</span>
  </span>
);

export default ClassicI2FBadge;
